import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { logConsole, logTransaction } from '../common/log';
import { handleThunkError } from '../common/util';
import { LogType } from '../models/log.model';
import { ConfigName, updateConfigString } from '../sqlite/common/config';

interface IUserState {
  selectedUsername: string;
}

const initialState: IUserState = {
  selectedUsername: ''
};

/// THUNKS

export const setSelectedUsernameStoreAsync = createAsyncThunk<{}, string>(
  'user/setSelectedUsernameStoreAsync',
  async (username, { rejectWithValue, dispatch }) => {
    logTransaction(LogType.Info, `Setting selected username '${username}' to storage`, '[user] setSelectedUsernameStoreAsync');
    try {
      dispatch(setSelectedUsernameState(username));
      await updateConfigString(ConfigName.SelectedUsername, username, false);
    } catch (err: any) {
      return handleThunkError(err, rejectWithValue, undefined, undefined);
    }
  }
);

/// SLICE

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedUsernameState: (state, action: PayloadAction<string>) => {
      logConsole(LogType.Info, '[user] setSelectedUsernameState');
      state.selectedUsername = action.payload;
    },
  }
});

/// REDUCERS

export const { setSelectedUsernameState } = userSlice.actions;

/// SELECTORS

export const selectUsersSearchState = (state: RootState) => state.user.selectedUsername;

export default userSlice.reducer;
